import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Image, Card, CardImage, Heading3 } from '@blueprint/ui';
import { FeatureList } from '@zoopla/listings/features';
import { ButtonIconOnly } from '@zoopla/blueprint-button-with-icon';

export const StyledLink = styled('a')(
    ({ theme: { spacing, focusRing } }) => css`
        margin: ${spacing['8px']};
        text-decoration: none;
        display: inline;
        :focus {
            box-shadow: ${focusRing};
            outline: 0;
        }
        :first-of-type {
            margin-left: 1rem;
        }
    `
);

export const StyledCard = styled(Card)(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        border-radius: ${theme.borderRadius['300']};
        padding: 0;
        height: 100%;
        width: 17.5rem;
        cursor: pointer;

        ${CardImage} {
            margin: 0;
            min-width: 100%;
            height: 100%;
            object-fit: cover;
        }
    `
);

export const CardDetails = styled('div')(
    ({ theme: { spacing } }) => css`
        margin: ${spacing['16px']};
        position: relative;

        ${FeatureList} {
            margin-top: ${spacing['8px']};
        }
    `
);

export const CardHeader = styled.div(
    () => css`
        position: relative;
        display: flex;
        justify-content: space-between;
    `
);

export const IconContainer = styled.div(
    () => css`
        display: flex;
        position: absolute;
        right: 0;
        top: 0;
    `
);

export const FeaturesContainer = styled.div(
    () => css`
        position: relative;
        display: flex;
        cursor: pointer;
    `
);

export const ImageContainer = styled.div(
    () => css`
        position: relative;
        display: flex;
        cursor: pointer;
    `
);

export const AgencyLogo = styled('div')(
    ({ theme: { spacing } }) => css`
        position: absolute;
        right: 0;
        top: 0;
        line-height: 1;
        max-width: ${spacing['80px']};

        ${Image} {
            max-height: ${spacing['48px']};
            width: auto;
            display: block;
        }
    `
);

export const PriceContainer = styled.div(() => css``);

export const StyledTitle = styled(Heading3)(
    ({ theme: { colors, spacing } }) => css`
        padding-top: ${spacing['8px']};
        color: ${colors['text-title']};
    `
);

export const PriceTitleText = styled('p')(
    ({ theme }) => css`
        margin: 0;
        line-height: ${theme.type.lineHeight};
        font-size: ${theme.type.secondary};
        color: ${theme.colors['text-body']};
        clear: both;
    `
);

export const CustomButton = styled(ButtonIconOnly)(
    ({ theme: { focusRing } }) => css`
        padding: 0px;
        margin: 0px;

        :hover:not(:focus) {
            transform: none;
            box-shadow: none;
        }

        :hover:focus {
            transform: none;
            box-shadow: ${focusRing};
        }

        svg {
            width: 100%;
            height: 100%;
        }
    `
);

export const BadgeWrapper = styled.div(
    ({ theme: { spacing } }) =>
        css`
            position: absolute;
            top: ${spacing['16px']};
            left: ${spacing['16px']};
        `
);
